import { render, staticRenderFns } from "./RequestsNavbar.vue?vue&type=template&id=bb9c6e1a&scoped=true&"
import script from "./RequestsNavbar.vue?vue&type=script&lang=js&"
export * from "./RequestsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./RequestsNavbar.vue?vue&type=style&index=0&id=bb9c6e1a&scoped=true&lang=css&"
import style1 from "./RequestsNavbar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9c6e1a",
  null
  
)

export default component.exports